const rnds8Pool = new Uint8Array(256); // # of random values to pre-allocate
let poolPtr = rnds8Pool.length;

const rng = () => {
  if (poolPtr > rnds8Pool.length - 16) {
    window.crypto.getRandomValues(rnds8Pool);
    poolPtr = 0;
  }

  return rnds8Pool.slice(poolPtr, (poolPtr += 16));
};

export default rng;
